import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher';
import assign from 'object-assign';

const ResourceDetailsStore = assign({}, EventEmitter.prototype, {

  _state: undefined,
  isLoading: false,

  init: function(){},

  _updateState: function(state){
    this._state = state;
    Dispatcher.emit(Dispatcher.RESOURCE_DETAILS_STORE_CHANGE);
  },

  _addToState: function(key, object) {
    this._state = this._state || {};
    this._state[key] = object;

    Dispatcher.emit(Dispatcher.RESOURCE_DETAILS_STORE_CHANGE);
  },

  get: function(id){
    this._load(id);
    return this._state ? this._state[id] : undefined;
  },

  // TODO: Remove if not being used
  getAll: function(){
    this._load();
    return this._state || [];
  },


  _load: function(id, update){
    if (!this.isLoading && (update || this._state === undefined || this._state[id] === undefined)){
      this.isLoading = true;
      Jigsaw.getAncillariesForVbid(id, (response) => {
        if (response.isSuccess()){
          this._addToState(id, response.data);
        }else{
          this._addToState(id, null);
        }
        this.isLoading = false;
      });
    }
  }

});

ResourceDetailsStore.init();
export default ResourceDetailsStore;
